import { useNavigate } from "react-router"
import { AntModal, Button } from "../../../components"

export type SelectedFeature = {
    numberOfApplications: number
    isEnabled: boolean
    flag: string
    feature: string
    reviewLink: string
}

type ToggleFeatureModelProps = {
    selectedFeature: SelectedFeature | null
    isToggleFeatureModalOpen: boolean
    onCancel: () => void
    onConfirm: () => void
}

const ToggleFeatureModel = ({ selectedFeature, isToggleFeatureModalOpen, onCancel, onConfirm }: ToggleFeatureModelProps) => {
  const navigate = useNavigate();
  const hasApplicationsMapped = selectedFeature && selectedFeature.numberOfApplications > 0;
  const hasApplicationsMappedContent = (
    <>
        You have {selectedFeature?.numberOfApplications} IT Applications currently mapped to {selectedFeature?.feature}.
        <br />
        <br />
        <b>Please review and remove all mapped IT Applications from the <button className="text-[#1684E4] underline" onClick={() => navigate(selectedFeature?.reviewLink ?? '#')}>{selectedFeature?.feature} Mapping screen</button> section before disabling it.</b>
        <br />
    </>
  );
  const hasNoApplicationsMappedContent = (
    <>
      You are about to disable the mapping of IT Applications for your {selectedFeature?.feature}.
      <br />
      <br />
      <b>Are you sure you want to do that?</b>
    </>
  );
  const content = hasApplicationsMapped ? hasApplicationsMappedContent : hasNoApplicationsMappedContent;
  return (
    <AntModal
        title={`Disable ${selectedFeature?.feature}`}
        openModal={isToggleFeatureModalOpen}
        onCancel={onCancel}
        width={700}
    >
        <div className="flex flex-col gap-4 text-base">
            <span>{content}</span>
            <div className={`flex flex-row gap-4 ${ hasApplicationsMapped ? 'justify-end' : 'justify-between' }`}>
                <Button
                type="primary"
                className="w-56 text-sm font-bold max-w-[260px] py-2"
                onClick={onCancel}
                >
                    Cancel
                </Button>
                {!hasApplicationsMapped && (
                    <Button
                    type="warning"
                    className="w-56 text-sm font-bold max-w-[260px] py-2 shadow-none border-red-400"
                    onClick={onConfirm}
                    >
                        Disable {selectedFeature?.feature}
                    </Button>
                )}
            </div>
        </div>
    </AntModal>
  )
}

export default ToggleFeatureModel;